/** @jsxImportSource @emotion/react */
import { Box, Skeleton } from '@mui/material'
import { sidebarSkeletonItemContainer } from './SidebarFooter.style'

interface SidebarFooterSkeletonProps {
  loading: boolean
  rows: number
  rowHeight: number
}

export const SidebarSkeleton: React.FC<SidebarFooterSkeletonProps> = ({
  loading,
  rows,
  rowHeight,
}) => {
  return (
    <>
      {loading &&
        Array(rows)
          .fill(0)
          .map((_, index) => (
            <Box key={index} css={sidebarSkeletonItemContainer(rowHeight)}>
              <Skeleton
                variant="text"
                width="100%"
                height={16}
                style={{ background: 'rgba(255, 255, 255, 0.1)' }}
              />
            </Box>
          ))}
    </>
  )
}
